module.exports = __webpack_public_path__ + "1cfcb23c2d0c8eb199d319180a75190e.png";